const api = [
  {
    name: 'list',
    desc: '获取列表',
    method: 'GET',
    path: '/secondary/prod/list'
  },
  {
    name: 'add',
    desc: '新增二手商品',
    method: 'POST',
    path: '/secondary/prod/add'
  },
  {
    name: 'changeStatus',
    desc: '更改状态',
    method: 'POST',
    path: '/secondary/prod/changeStatus'
  },
  {
    name: 'detail',
    desc: '商品详情',
    method: 'GET',
    path: '/secondary/prod/detail'
  },
  //
  {
    name: 'getLevel',
    desc: '获取新旧程度列表',
    method: 'get',
    path: '/secondary/prod/getLevel'
  },
  // 答疑
  {
    name: 'askOrReply',
    desc: '发布/回复 问题',
    method: 'get',
    path: '/secondary/prod/askOrReply'
  },
  //删除
  {
    name: 'deleteAsk',
    desc: '发布/回复 问题',
    method: 'get',
    path: '/secondary/prod/askOrReply/delete'
  },
  {
    name: 'reply',
    desc: '获取所有咨询问题信息',
    method: 'post',
    path: '/secondary/prod/askOrReply'
  },
  //
  {
    name: 'getAllList',
    desc: '获取所有二手商品',
    method: 'GET',
    path: '/secondary/prod/getAllList'
  },
  {
    name: 'audit',
    desc: '更改状态(下架)',
    method: 'post',
    path: '/secondary/prod/audit'
  }
]

export default {
  BASE_URL: '',
  NAMESPACE: 'secondary',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/self/secondhand/index.js